<template>
    <td-dialog
        :title="title"
        @cancel="dialogAdvanceClose"
        :before-close="dialogAdvanceClose"
        :visible.sync="dialogAdvancedVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="760px"
        height="50%"
        top="18vh"
    >
        <el-form :model="formAdvance" :label-width="formLabelWidth" ref="formAdvance">
            <el-row v-for="(item, index) in rows" :key="index">
                <div v-if="rows[index].rowVisible">
                    <el-col v-if="item.value !== 1" :span="4">
                        <el-form-item>
                            <td-select v-model="rows[index].condition" :placeholder="$t('pgCommon.PLEASE_SELECT')" width="100" :options="optionCondition" keys="value" text="label"></td-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-else-if="item.value === 1" :span="4">
                        <el-form-item></el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('pgCommon.PROPERTY_NAME')" :label-width="labelWidth">
                            <td-select
                                v-model="rows[index].property"
                                :placeholder="$t('pgCommon.PLEASE_SELECT')"
                                width="120"
                                :options="propertyList"
                                keys="sColumnName"
                                text="sColumnNotes"
                            ></td-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item>
                            <td-select v-model="rows[index].optionFlg" :placeholder="$t('pgCommon.PLEASE_SELECT')" width="100" :options="optionValue" keys="value"></td-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('pgCommon.VALUE')">
                            <td-input v-model="rows[index].inputValue" width="150"></td-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="item.value !== 1" :span="4">
                        <el-form-item>
                            <td-button type="button" size="small" @click="deleteRow(index)">{{ $t('pgCommon.DELETE') }}</td-button>
                        </el-form-item>
                    </el-col>
                </div>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="button" @click="addCondition">{{ $t('pgCommon.ADD_CONDITION') }}</td-button>
            <td-button type="primary" :permissions="permissionsQuery" @click="btnAdvanceQuery">{{ $t('pgCommon.QUERY') }}</td-button>
            <td-button type="button" @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'propertyList', 'dialogAdvancedVisible'],
    created() {},
    // 定义变量
    data() {
        return {
            // 表单信息
            formAdvance: {},
            indexValue: 1,
            optionCondition: [
                {
                    value: 'AND',
                    label: '与'
                },
                {
                    value: 'OR',
                    label: '或'
                }
            ],
            optionValue: [
                {
                    value: 'EQ',
                    label: '等于'
                },
                {
                    value: 'CONTAIN',
                    label: '包含'
                },
                {
                    value: 'GT',
                    label: '大于'
                },
                {
                    value: 'LT',
                    label: '小于'
                },
                {
                    value: 'NOTEQ',
                    label: '不等于'
                }
            ],
            // 条件行
            rows: [
                {
                    value: 1,
                    condition: 'AND',
                    property: '',
                    optionFlg: 'EQ',
                    inputValue: '',
                    rowVisible: true
                },
                {
                    value: 2,
                    condition: 'AND',
                    property: '',
                    optionFlg: 'EQ',
                    inputValue: '',
                    rowVisible: true
                }
            ],
            formLabelWidth: '10%',
            labelWidth: '60px'
        };
    },
    // 定义并实现方法体
    methods: {
        // 取消
        cancel() {
            this.dialogAdvanceClose();
        },

        // 关闭窗口之前需要调用的方法
        dialogAdvanceClose() {
            this.$emit('dialogAdvanceClose');
        },

        // 添加条件
        addCondition() {
            if (this.indexValue === 10) {
                return;
            }
            this.indexValue++;
            this.rows.push({
                value: this.indexValue,
                condition: 'AND',
                property: '',
                optionFlg: 'EQ',
                inputValue: '',
                rowVisible: true
            });
        },

        // 提交条件
        btnAdvanceQuery() {
            let conditionList = [];
            for (let index = 0; index < this.rows.length; index++) {
                const element = this.rows[index];
                if (index === 0) {
                    let param = {
                        field: element.property,
                        condition: this.strChangeSymbol(element.optionFlg),
                        value: element.inputValue,
                        joint: ''
                    };
                    conditionList[0] = param;
                } else {
                    let param = {
                        field: element.property,
                        condition: this.strChangeSymbol(element.optionFlg),
                        value: element.inputValue,
                        joint: element.condition
                    };
                    conditionList[index] = param;
                }
            }
            this.$emit('advanceQuery', conditionList);
            this.$emit('dialogAdvanceClose');
        },

        // 字符串转符号
        strChangeSymbol(str) {
            if (str === 'CONTAIN') {
                return 'LIKE';
            } else if (str === 'NOTEQ') {
                return '<>';
            } else if (str === 'GT') {
                return '>';
            } else if (str === 'LT') {
                return '<';
            } else {
                return '=';
            }
        },

        // 删除行
        deleteRow(index) {
            if (index > 1) {
                this.indexValue--;
            }
            this.rows.splice(index, 1);
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
